import { ConfigProvider } from 'antd';
import enUS from 'antd/locale/en_US';
import jaJP from 'antd/locale/ja_JP';
import type { FC, PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import '@fontsource/noto-sans-jp/japanese-400.css';
import '@fontsource/noto-sans-jp/japanese-500.css';
import '@fontsource/noto-sans-jp/japanese-700.css';
import { DEFAULT_FONT_FAMILY } from '@/utils';

export const DesignProvider: FC<PropsWithChildren> = ({ children }) => {
  const { i18n } = useTranslation();
  const locale = i18n.language === 'ja' ? jaJP : enUS;

  return (
    <ConfigProvider
      locale={locale}
      theme={{
        token: {
          fontFamily: DEFAULT_FONT_FAMILY,
          colorBgMask: 'rgba(0, 0, 0, 0.60)',
          colorBorder: '#D0D0D0',
          colorBorderSecondary: '#DADADA',
          colorError: '#F5222D',
          colorErrorActive: '#CF1322',
          colorErrorBg: '#FFF1F0',
          colorErrorBgHover: '#FFCCC7',
          colorErrorBorder: '#FFA39E',
          colorErrorBorderHover: '#FFCCC7',
          colorErrorText: '#F5222D',
          colorErrorTextActive: '#CF1322',
          colorFill: 'rgb(0,0,0,0.12)',
          colorFillTertiary: 'rgba(0, 0, 0, 0.04)',
          colorLink: '#248464',
          colorLinkHover: '#3BA182',
          colorPrimary: '#248464',
          colorPrimaryActive: '#186449',
          colorPrimaryBg: '#E0F1ED',
          colorPrimaryBgHover: '#B4DDD0',
          colorPrimaryBorder: '#58B296',
          colorPrimaryBorderHover: '#85C8B3',
          colorPrimaryHover: '#3BA182',
          colorPrimaryText: '#248464',
          colorPrimaryTextActive: '#186449',
          colorPrimaryTextHover: '#3BA182',
          colorText: 'rgb(0,0,0,0.85)',
          colorTextBase: 'rgb(0,0,0,0.85)',
          colorTextSecondary: 'rgb(0,0,0,0.60)',
        },
        components: {
          Layout: {
            bodyBg: 'transparent',
          },
          Tooltip: {
            colorTextLightSolid: 'rgb(0,0,0,0.85)',
            colorBgSpotlight: '#E0F1ED',
          },
          Table: {
            headerBg: '#F5F5F5',
            rowHoverBg: '#F5F5F5',
            rowSelectedBg: '#E0F1ED',
            rowExpandedBg: '#F5F5F5',
            headerBorderRadius: 0,
            fontWeightStrong: 500,
          },
          Card: {
            boxShadowTertiary:
              '0 1px 2px 0 rgba(0, 0, 0, 0.04), 0 1px 6px -1px rgba(0, 0, 0, 0.06), 0 1px 8px 0 rgba(0, 0, 0, 0.08)',
          },
          Avatar: {
            colorTextPlaceholder: '#bfbfbf',
          },
        },
      }}
    >
      {children}
    </ConfigProvider>
  );
};
